import { Component, OnInit, Inject, Output, Pipe, EventEmitter, Input } from '@angular/core';
import { HttpEventType, HttpClient, HttpHeaders } from '@angular/common/http';
import { DownloadingInfo } from '../model/downloading.model';

import {
  environment
} from 'src/environments/environment';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})




export class UploadComponent implements OnInit {
 
  public bodyuploading: string;
  public uploadcount: number;

  public downloadlist: any[];
  public itragetuploadstart: number;
  public itragetuploadprogress: number;

  @Output() public onUploadFinished = new EventEmitter();
  @Output() public onUploadStarted = new EventEmitter();

  @Input() PathFile: string;
  @Input() ButtonName: string;
  @Input() Single: string;
  @Input() Multiple: string;


  

  baseurl: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseurl = environment.base_api;
    this.itragetuploadstart = 0;
    this.itragetuploadprogress = 0;
    this.uploadcount = 0;
    this.downloadlist = [];
   
  }
  ngOnInit() {
    if (this.Multiple == "true") {
      // move box uploading to body
      var checkExist = setInterval(function () {
        if ($('#UploadingBox').length) {
          $("#UploadingBox").appendTo("body");
          $("#UploadingBox").fadeIn();
          clearInterval(checkExist);
        }
      }, 100); // check every 100ms
    }
   

  }

  add() {

    this.downloadlist.push({
      Filename: '1001', size: 212, progress: 9
    });
      
  }



  public uploadFile = (files) => {
    this.onUploadStarted.emit();
    // reset list download
    this.downloadlist = [];

    if (files.length === 0) {
      return;
    }
    let filesToUpload: File[] = files;
 
    Array.from(filesToUpload).map((file, index) => {
          // push uoload list
      this.AdduploadingList(file.name);
      const formData = new FormData();
      formData.append("pathfile", this.PathFile);
      formData.append('file' + index, file, file.name);

      // check upload count
      let check = this.downloadlist.filter(function (item) {
        return item.progress != 100;
      });

      this.uploadcount = check.length;
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

          

            // check current file is set size
            let check = this.downloadlist.filter(function (item) {
              return item.size == event.total;
            });

            // is not set 
            if (check.length == 0) {
              // update size list
              this.Updateuploadingsizelist(Number(event.total));
            }

            if (progress >= 1) {
              // update progress
              this.Updateuploadingprogresslist(Number(event.total), progress);
            }
            

            if (progress == 100) {
              // check upload count
              let check = this.downloadlist.filter(function (item) {
                return item.progress != 100;
              });

              this.uploadcount = check.length;
            }

          } else if (event.type === HttpEventType.Response) {
              this.onUploadFinished.emit(event.body);
            
          }
        });


    });

    
  }

  public AdduploadingList(filename: string) {
    this.itragetuploadstart = this.itragetuploadstart + 1;

    this.downloadlist.push({ Filename: filename, size: 0, traget: this.itragetuploadstart, progress: 0 })

  }

  public Updateuploadingsizelist(sizefile: number) {
    this.itragetuploadprogress = this.itragetuploadprogress + 1;

    let itemIndex = this.downloadlist.findIndex(item => item.traget == this.itragetuploadprogress && item.size == 0);
    if (itemIndex != -1) {
      this.downloadlist[itemIndex].size = sizefile;

    }
  }


  public Updateuploadingprogresslist(sizefile: number, progress: number) {

    let itemIndex = this.downloadlist.findIndex(item => item.size == sizefile);
    if (itemIndex != -1) {
      this.downloadlist[itemIndex].progress = progress;

    }
  }
}
